import { render } from "./WarehouseItem.vue?vue&type=template&id=626988b8&scoped=true"
import script from "./WarehouseItem.vue?vue&type=script&lang=js"
export * from "./WarehouseItem.vue?vue&type=script&lang=js"

import "./WarehouseItem.vue?vue&type=style&index=0&id=626988b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626988b8"]])

export default __exports__